import React from 'react'
import { connect } from 'react-redux'
import { Button, Grid, Col, Row } from 'react-bootstrap'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { SelectSearchContainer } from '../../components/shared'
import { Loading } from '../../components/shared'
import { getSubmissionRevisions } from '../api'
import { submission as submissionUtils } from '../../utils'
import { formatDollars } from '../../utils/utilities'
import { updateManualQuoteStatus, downloadQuoteRevisionSubmission } from '../actions'
import { Download } from 'lucide-react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/free-solid-svg-icons'
import PDFPreview from './PDFPreview'
import { CalendarDays } from 'lucide-react'
import Cleave from 'cleave.js/dist/cleave-react'
import classNames from 'classnames'
import moment from 'moment'
import { formatDate, parseDate } from '../../utils/utilities.js'
import { DayPicker } from 'react-day-picker'

export const QUOTE_STATUS_DECLINED = 'DECLINED'
export const QUOTE_STATUS_BOUND_MANUAL = 'BOUNDMANUAL'

export const MANUAL_QUOTE_STATUS_OPTIONS = [
  {
    display: 'Bound',
    code: QUOTE_STATUS_BOUND_MANUAL,
  },
  {
    display: 'Declined',
    code: QUOTE_STATUS_DECLINED,
  },
]

class ChangeQuoteStatusModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      manualQuoteStatus: '',
      manualQuoteStatusUpdatedAt: null,
      primaryPolicyNumber: undefined,
      selectedSubmission: null,
      enableSave: false,
      loading: false,
      saveLoading: false,
      hasExpired: false,
      showPolicyNumber: false,
      validationMessages: [],
      statusOptionsList: [],
      declineComment: undefined,
      revisionsDisplay: null,
      selectedRevisionForBound: null,
      effDate: '',
      expDate: '',
      effDateHolder: null,
      expDateHolder: null,
      validEffDate: false,
      validExpDate: false,
      openEffCalendarFlag: false,
      openExpCalendarFlag: false,
      selectedRevisionRow: null,
      filterPDFByCoverage: null,
      type: null,
    }
    this.handleStatusChange = this.handleStatusChange.bind(this)
    this.handlePolicyNumberChange = this.handlePolicyNumberChange.bind(this)
    this.validateSuccess = this.validateSuccess.bind(this)
    this.handleSave = this.handleSave.bind(this)
    this.handleDeclineComment = this.handleDeclineComment.bind(this)
    this.handleDeclineCommentOnBlur = this.handleDeclineCommentOnBlur.bind(this)
    this.downloadQuote = this.downloadQuote.bind(this)
    this.handleHidePdf = this.handleHidePdf.bind(this)
    this.handleShowPdf = this.handleShowPdf.bind(this)
    this.handleSelectBoundRevision = this.handleSelectBoundRevision.bind(this)
    this.formatActionColumn = this.formatActionColumn.bind(this)
    this.formatDateColumn = this.formatDateColumn.bind(this)
    this.populateRevisionsDisplayData = this.populateRevisionsDisplayData.bind(this)
    this.handleEffDateChange = this.handleEffDateChange.bind(this)
    this.handleExpDateChange = this.handleExpDateChange.bind(this)
    this.handleOpenEffCalendar = this.handleOpenEffCalendar.bind(this)
    this.handleOpenExpCalendar = this.handleOpenExpCalendar.bind(this)
    this.handleEffDate = this.handleEffDate.bind(this)
    this.handleExpDate = this.handleExpDate.bind(this)
    this.requiredFieldsComplete = this.requiredFieldsComplete.bind(this)
    this.findSelectedRevisionRow = this.findSelectedRevisionRow.bind(this)
  }

  componentDidMount = () => {
    this.setState(
      {
        loading: true,
      },
      async () => {
        try {
          const response = await getSubmissionRevisions(
            this.props.user,
            { id: this.props.selectedSubmissionRow },
            false,
          )
          const submissionWithRevisions = response?.data
          if (submissionWithRevisions) {
            let primaryPolicyNumber
            let declineComment
            let showPolicyNumber = false
            let effDate = ''
            let expDate = ''
            let selectedRevisionForBound = null
            const boundInfo = submissionWithRevisions.manualQuoteStatusAddlInfo?.boundInfo

            // populate primaryPolicyNumber logic
            if (
              submissionWithRevisions.primaryPolicyNumber &&
              (submissionWithRevisions.manualQuoteStatus === QUOTE_STATUS_BOUND_MANUAL ||
                (this.props.isBound &&
                  submissionWithRevisions.manualQuoteStatus !== QUOTE_STATUS_DECLINED))
            ) {
              primaryPolicyNumber = submissionWithRevisions.primaryPolicyNumber.trim()
            } else if (submissionWithRevisions.primaryPolicyNumber !== undefined) {
              primaryPolicyNumber = ''
            }

            // populate additional bound info data.
            if (submissionWithRevisions.manualQuoteStatus === QUOTE_STATUS_BOUND_MANUAL) {
              effDate = boundInfo?.boundEffectiveDate ? boundInfo.boundEffectiveDate : ''
              expDate = boundInfo?.boundExpirationDate
                ? boundInfo.boundExpirationDate
                : ''

              if (boundInfo?.boundRevisionNumber) {
                selectedRevisionForBound = {
                  revisionNumber: boundInfo.boundRevisionNumber,
                  isStandardForDedWarranty:
                    boundInfo.isBoundStandardForDedWarranty === true ? true : false,
                  isSelected: true, // if a revisionNumber is present then it is selected
                }
              }
            }

            // populate Decline Comment logic
            if (
              submissionWithRevisions.declineComment &&
              submissionWithRevisions.manualQuoteStatus === QUOTE_STATUS_DECLINED
            ) {
              declineComment = submissionWithRevisions.declineComment.trim()
            } else if (submissionWithRevisions.declineComment !== undefined) {
              declineComment = ''
            }

            // Populate revisions data
            const revisionsDisplayData = this.populateRevisionsDisplayData(
              submissionWithRevisions,
            )

            // set showPolicyNumber logic
            if (
              submissionWithRevisions.manualQuoteStatus === QUOTE_STATUS_BOUND_MANUAL ||
              (this.props.isBound &&
                submissionWithRevisions.manualQuoteStatus !== QUOTE_STATUS_DECLINED)
            ) {
              showPolicyNumber = true
            }

            // set submission type
            const { type } = submissionWithRevisions.revisions?.find((revision) => {
              if (typeof revision.type === 'string' && revision.type.length > 0) {
                return true
              }
              return false
            })

            const statusOptionsList =
              this.props.isBound &&
              submissionWithRevisions.manualQuoteStatus !== QUOTE_STATUS_BOUND_MANUAL
                ? MANUAL_QUOTE_STATUS_OPTIONS.filter(
                    (item) => item.code !== QUOTE_STATUS_BOUND_MANUAL,
                  )
                : MANUAL_QUOTE_STATUS_OPTIONS
            this.setState({
              selectedSubmission: submissionWithRevisions,
              manualQuoteStatus: submissionWithRevisions.manualQuoteStatus
                ? submissionWithRevisions.manualQuoteStatus.trim()
                : '',
              manualQuoteStatusUpdatedAt:
                submissionWithRevisions.manualQuoteStatusUpdatedAt,
              primaryPolicyNumber: primaryPolicyNumber,
              statusOptionsList: statusOptionsList,
              showPolicyNumber: showPolicyNumber,
              enableSave: true,
              loading: false,
              declineComment: declineComment,
              revisionsDisplay: revisionsDisplayData,
              effDate,
              validEffDate: effDate ? true : false,
              expDate,
              validExpDate: expDate ? true : false,
              selectedRevisionForBound,
              type,
            })
          }
        } catch (e) {
          console.log('Error getting submission data...')
        }
      },
    )
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.loading === false && prevProps.loading === true) {
      if (this.state.saveLoading === true) {
        this.setState(
          {
            saveLoading: false,
            enableSave: true,
          },
          () => {
            this.props.onHide()
          },
        )
      }
    }
  }

  handleStatusChange = (selectedOption) => {
    if (selectedOption && selectedOption.value === QUOTE_STATUS_BOUND_MANUAL) {
      this.setState({
        manualQuoteStatus: selectedOption.value,
        showPolicyNumber: true,
        declineComment: '',
      })
    } else {
      let showPolicyNumber = false
      if (
        this.props.isBound &&
        (!selectedOption || selectedOption.value !== QUOTE_STATUS_DECLINED)
      ) {
        showPolicyNumber = true
      }
      this.setState({
        manualQuoteStatus:
          selectedOption && selectedOption.value ? selectedOption.value : '',
        showPolicyNumber: showPolicyNumber,
        primaryPolicyNumber: '',
        declineComment: '',
        selectedRevisionForBound: null,
        effDate: '',
        expDate: '',
      })
    }
  }

  handlePolicyNumberChange = (event) => {
    let value = ''
    if (typeof event.target.value === 'string') {
      value = event.target.value
    }
    this.setState({
      primaryPolicyNumber: value,
    })
  }

  handleDeclineComment = (event) => {
    let value = ''
    if (typeof event.target.value === 'string') {
      value = event.target.value
    }
    this.setState({
      declineComment: value,
    })
  }

  handleDeclineCommentOnBlur = (event) => {
    let value = ''
    if (typeof event.target.value === 'string') {
      value = event.target.value.trim()
    }
    this.setState({
      declineComment: value,
    })
  }

  validateSuccess = () => {
    let validationFailed = false
    let validationMessages = []
    // Check Declined 90 Day rule.
    if (
      this.state.selectedSubmission.manualQuoteStatus === QUOTE_STATUS_DECLINED &&
      this.state.selectedSubmission.manualQuoteStatusUpdatedAt &&
      submissionUtils.hasExpired(
        this.state.selectedSubmission.manualQuoteStatusUpdatedAt,
        90,
      )
    ) {
      validationMessages.push({
        key: 'DECLINE_90DAYS',
        message: 'Cannot change Declined status after 90 days.',
      })
      validationFailed = true
    }

    this.setState({
      validationMessages: validationMessages,
    })

    return !validationFailed
  }

  handleSave = (event) => {
    event.preventDefault()
    if (this.validateSuccess() && this.state.selectedSubmission !== null) {
      this.setState(
        {
          saveLoading: true,
          enableSave: false,
        },
        () => {
          let payload = {
            manualQuoteStatus: this.state.manualQuoteStatus,
            manualQuoteStatusUpdatedAt: new Date().toISOString(),
            primaryPolicyNumber: '',
            declineComment: '',
            manualQuoteStatusAddlInfo: null,
          }
          if (this.state.manualQuoteStatus === QUOTE_STATUS_BOUND_MANUAL) {
            payload = {
              ...payload,
              primaryPolicyNumber: this.state.primaryPolicyNumber,
              manualQuoteStatusAddlInfo: {
                boundInfo: {
                  boundEffectiveDate: this.state.effDate,
                  boundExpirationDate: this.state.expDate,
                  boundRevisionNumber:
                    this.state.selectedRevisionForBound?.revisionNumber,
                  isBoundStandardForDedWarranty:
                    this.state.selectedRevisionForBound?.isStandardForDedWarranty,
                },
              },
            }
          } else if (this.state.manualQuoteStatus === QUOTE_STATUS_DECLINED) {
            payload = {
              ...payload,
              declineComment: this.state.declineComment,
            }
          }

          /**
           * The call to updateManualQuoteStatus ends up populating the submissionDataUpdatedFromModalArray array in redux.
           * The submission grid in SubmissionsListFeedTable component uses this array to determine
           * what the manualQuoteStatus value is as the grid can sometimes load before elastic search is updated
           * so the UI would not show the correct manualQuoteStatus value without the submissionDataUpdatedFromModalArray
           * array.
           */

          this.props.updateManualQuoteStatus(
            this.state.selectedSubmission.id,
            payload,
            this.props.user,
            this.props.refetchSubmissions,
            () => {
              this.setState({ saveLoading: false, enableSave: true }, () => {
                this.props.onHide();
              });
            }
          )
        },
      )
    }
  }

  downloadQuote = (id, revisionNumber, coverage, isDedWarrantySystemGen) => {
    const filterPDFByCoverage = isDedWarrantySystemGen ? coverage : null
    this.props.downloadQuoteRevisionSubmission(
      this.props.user,
      id,
      revisionNumber,
      filterPDFByCoverage,
    )
  }

  handleHidePdf = () => {
    this.setState({
      showPDFPreview: false,
      showPdf: false,
    })
  }

  handleShowPdf = (revisionNumber, coverage, isDedWarrantySystemGen) => {
    this.setState({
      showPDFPreview: true,
      showPdf: true,
      selectedRevision: revisionNumber,
      filterPDFByCoverage: isDedWarrantySystemGen ? coverage : null,
    })
  }

  handleSelectBoundRevision = (row, isSelected = false, e) => {
    if (row) {
      this.setState({
        selectedRevisionForBound: {
          revisionNumber: row.revisionNumber,
          isStandardForDedWarranty: row.isStandardForDedWarranty === true ? true : false,
          isSelected,
        },
      })
    }
  }

  formatDateColumn = (cell, row) => {
    const date = new Date(cell)
    return new Intl.DateTimeFormat('en', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      timeZone: 'UTC',
    }).format(date)
  }

  formatActionColumn = (cell, row) => {
    return (
      <div>
        <Button
          onClick={(event) =>
            this.downloadQuote(
              row.id,
              row.revisionNumber,
              row.coverage,
              row.isDedWarrantySystemGen,
            )
          }
        >
          <Download size={16} />
        </Button>
        <Button
          onClick={() =>
            this.handleShowPdf(
              row.revisionNumber,
              row.coverage,
              row.isDedWarrantySystemGen,
            )
          }
        >
          <FontAwesomeIcon icon={faEye} />
        </Button>
      </div>
    )
  }

  populateRevisionsDisplayData = (submissionWithRevisions) => {
    const { id, commission, revisions } = submissionWithRevisions

    let quoteVersionCounter = 0
    let key = 0
    const revisionsDisplayData = []
    revisions.forEach((revision) => {
      const { type } = revision
      const revisionTotalPremium = revision.ratings[type].totalPremium
      const revisonCommission = Object.hasOwn(revision, 'adjustedCommission')
        ? revision.adjustedCommission
        : commission
      const revisionDate = revision.createdAt
      const revisionNumber = revision.revisionNumber
      const revisionCoverage = revision.coverages?.gl?.base
      let quoteNumberDisplay

      // Calc revisionNumber as it should appear on the Quote PDFs
      let isDedWarrantySystemGen = false
       if (revision.revisionState.includes('DRAFT')) {
        // draft condition
        quoteNumberDisplay = quoteVersionCounter
      } else if (
        revision.coverages.gl.base === 'deductibleWarranty' &&
        revision.manuallySetPricing !== 'true' &&
        revision.excessOnly !== true
      ) {
        /**
         * System Generated with Deductible Warranty condition. Will need to add a Standard Coverage
         * row to revisionsDisplayData.
         */
        quoteNumberDisplay = quoteVersionCounter + 1
        quoteVersionCounter = quoteVersionCounter + 2
        isDedWarrantySystemGen = true
      } else {
        quoteNumberDisplay = quoteVersionCounter + 1
        quoteVersionCounter = quoteVersionCounter + 1
      }

      /**
       * Condition is similar to OCP Bind logic.  If a submission has Referral rule then
       * make sure it is set to Manual Pricing which means the UW has reviewed the quote.
       */
      if (
        (!revision.ratings[type].failedReferralRules ||
          revision.manuallySetPricing === 'true') &&
        (!Object.hasOwn(revision, 'quoteDrafted') || revision.quoteDrafted === 'false') &&
        revision.transactionStatus !== 'IP'
      ) {
        key += 1
        revisionsDisplayData.push({
          totalPremium: revisionTotalPremium,
          commission: revisonCommission,
          date: revisionDate,
          id,
          quoteNumberDisplay,
          key,
          revisionNumber,
          type,
          coverage: revisionCoverage,
          isDedWarrantySystemGen,
        })

        // Add Standard Coverage Revision Display Row when revision is a System Gen Deductible Warranty
        if (isDedWarrantySystemGen) {
          key += 1
          revisionsDisplayData.push({
            totalPremium: null, // App does not record the Standard Total for System Generated Ded Warranty
            commission: revisonCommission,
            date: revisionDate,
            id,
            quoteNumberDisplay: quoteNumberDisplay + 1,
            key,
            revisionNumber,
            isStandardForDedWarranty: true,
            type,
            coverage: 'standard',
            isDedWarrantySystemGen,
          })
          isDedWarrantySystemGen = false
        }
      }
    })
    return revisionsDisplayData.sort(
      (a, b) =>
        Number.parseInt(b.quoteNumberDisplay) - Number.parseInt(a.quoteNumberDisplay),
    )
  }

  handleEffDateChange = (event) => {
    if (event.target.value.length === 10) {
      this.setState({
        effDate: new Date(event.target.value).toISOString(),
        validEffDate: true,
      })
    } else {
      this.setState({
        effDateHolder: event.target.value,
        effDate: '',
        validEffDate: false,
      })
    }
  }

  handleExpDateChange = (event) => {
    if (event.target.value.length === 10) {
      this.setState({
        expDate: new Date(event.target.value).toISOString(),
        validExpDate: true,
      })
    } else {
      this.setState({
        expDateHolder: event.target.value,
        expDate: '',
        validExpDate: false,
      })
    }
  }

  handleOpenEffCalendar = () => {
    if (this.state.openEffCalendarFlag !== true) {
      this.setState({
        openEffCalendarFlag: true,
      })
    } else {
      this.setState({
        openEffCalendarFlag: false,
      })
    }
  }

  handleOpenExpCalendar = () => {
    if (this.state.openExpCalendarFlag !== true) {
      this.setState({
        openExpCalendarFlag: true,
      })
    } else {
      this.setState({
        openExpCalendarFlag: false,
      })
    }
  }

  handleEffDate = (day) => {
    if (day instanceof Date) {
      this.setState({
        validEffDate: true,
        effDate: day.toISOString(),
        openEffCalendarFlag: false,
      })
    }
  }

  handleExpDate = (day) => {
    if (day instanceof Date) {
      this.setState({
        validExpDate: true,
        expDate: day.toISOString(),
        openExpCalendarFlag: false,
      })
    }
  }

  // validate required fields are complete. Assume true unless any field is incomplete.
  requiredFieldsComplete = () => {
    let complete = true
    if (
      this.state.manualQuoteStatus === QUOTE_STATUS_BOUND_MANUAL &&
      this.state.type === 'oi'
    ) {
      if (this.state.validEffDate !== true) {
        complete = false
      } else if (this.state.validExpDate !== true) {
        complete = false
      } else if (this.state.selectedRevisionForBound?.isSelected !== true) {
        complete = false
      } else if (
        this.state.effDate &&
        this.state.expDate &&
        new Date(this.state.expDate).getTime() <= new Date(this.state.effDate).getTime()
      ) {
        complete = false
      }
    }
    return complete
  }

  findSelectedRevisionRow = () => {
    if (
      !Array.isArray(this.state.revisionsDisplay) ||
      this.state.selectedRevisionForBound?.revisionNumber === undefined
    ) {
      return null
    }
    const selectedRevisionForBound = this.state.selectedRevisionForBound
    const foundIndex = this.state.revisionsDisplay.findIndex((revision) => {
      /**
       * if isStandardForDedWarranty is true check that the revisionNumber matches
       * and isStandardForDedWarranty is true which signifies the Standard Coverage row. Else
       * just return the found index if the revisionNumber matches
       */
      if (selectedRevisionForBound.isStandardForDedWarranty === true) {
        if (
          selectedRevisionForBound.revisionNumber === revision.revisionNumber &&
          revision.isStandardForDedWarranty === true
        ) {
          return true
        }
      } else {
        if (
          selectedRevisionForBound.revisionNumber === revision.revisionNumber &&
          revision.isStandardForDedWarranty !== true
        ) {
          return true
        }
      }
      return false
    })
    return foundIndex > -1 ? this.state.revisionsDisplay.length - foundIndex : null
  }

  render = () => {
    const { effDate, expDate } = this.state
    let modifiedEffDate = new Date(effDate)
    let modifiedExpDate = new Date(expDate)
    let disableExpDate = !!effDate ? new Date(effDate) : new Date()
    const currentYear = new Date().getFullYear()

    const requiredFieldsComplete = this.requiredFieldsComplete()
    const selectedRevisionRow = this.findSelectedRevisionRow()

    return (
      <div>
        {this.state.loading && (
          <div className="modal-loader">
            <Loading width="44px" height="44px" />
          </div>
        )}
        {!this.state.loading && (
          <div className="modal-main">
            <Grid fluid={true}>
              <Row>
                <Col xs={12} md={8}>
                  <label className="input-label">
                    <b>Additional Status Options:</b>
                  </label>
                  <div>
                    <SelectSearchContainer
                      options={this.state.statusOptionsList}
                      labelColumn={'display'}
                      valueColumn={'code'}
                      value={this.state.manualQuoteStatus}
                      onChange={this.handleStatusChange}
                      id="manualQuoteStatusDropdownEdit"
                      placeHolder="Select status..."
                    />
                    <br />
                    {this.state.manualQuoteStatus === QUOTE_STATUS_DECLINED && (
                      <div>
                        <label className="input-label">
                          <b>Decline Reason:</b>
                        </label>{' '}
                        <input
                          type="text"
                          className="text-input2"
                          onChange={this.handleDeclineComment}
                          onBlur={this.handleDeclineCommentOnBlur}
                          placeholder="Optional"
                          value={this.state.declineComment || ''}
                        />
                      </div>
                    )}
                  </div>
                  {this.state.showPolicyNumber && (
                    <div>
                      <label className="input-label">
                        <b>Primary Policy Number:</b>
                      </label>
                      <input
                        type="text"
                        className="text-input2"
                        onChange={this.handlePolicyNumberChange}
                        value={this.state.primaryPolicyNumber || ''}
                      />
                    </div>
                  )}
                </Col>
              </Row>
              {this.state.manualQuoteStatus === QUOTE_STATUS_BOUND_MANUAL &&
                this.state.type === 'oi' && (
                  <>
                    <Row>
                      <Col xs={12} md={12}>
                        <label className="input-label">
                          <b>*Which quote revision are you requesting for bind?</b>
                        </label>
                        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                          <BootstrapTable
                            data={this.state.revisionsDisplay}
                            maxHeight="140px"
                            maxWidth="40px"
                            scrollTop={'Top'}
                            bodyContainerClass="revision-table-body"
                            selectRow={{
                              mode: 'radio',
                              onSelect: this.handleSelectBoundRevision,
                              selected: [selectedRevisionRow],
                            }}
                          >
                            <TableHeaderColumn
                              dataAlign="center"
                              dataField="quoteNumberDisplay"
                              width="15%"
                            >
                              Quote Version
                              <br />
                              Number
                            </TableHeaderColumn>
                            <TableHeaderColumn
                              dataAlign="center"
                              dataField="totalPremium"
                              dataFormat={(cell) => formatDollars(cell, 'N/A', true)}
                            >
                              Total Premium
                            </TableHeaderColumn>
                            <TableHeaderColumn dataAlign="center" dataField="commission">
                              Commission %
                            </TableHeaderColumn>
                            <TableHeaderColumn
                              dataAlign="center"
                              dataField="date"
                              dataFormat={this.formatDateColumn}
                            >
                              Date Quoted
                            </TableHeaderColumn>
                            <TableHeaderColumn
                              isKey
                              dataAlign="center"
                              dataField="key"
                              dataFormat={this.formatActionColumn}
                            >
                              Download
                            </TableHeaderColumn>
                          </BootstrapTable>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} md={3}>
                        <div className="quote-status-date">*Effective Date:</div>
                      </Col>
                      <Col xs={4} md={3}>
                        <Cleave
                          id={'effDate'}
                          className={classNames(
                            'form-control',
                            'number-control',
                            'input-numeral',
                            'quote-status-date',
                            {
                              filled: this.state.effDate
                                ? moment(this.state.effDate).format('MM/DD/YYYY')
                                : this.state.effDateHolder,
                            },
                          )}
                          value={
                            this.state.effDate
                              ? moment(this.state.effDate).format('MM/DD/YYYY')
                              : this.state.effDateHolder
                          }
                          placeholder="mm/dd/yyyy"
                          options={{
                            date: true,
                            datePattern: ['m', 'd', 'Y'],
                          }}
                          onChange={this.handleEffDateChange}
                        />
                      </Col>
                      <Col>
                        <div className="modalDatePicker">
                          <button
                            className="calendarButton quote-status-date"
                            onClick={this.handleOpenEffCalendar}
                          >
                            <CalendarDays size={16} color="#42b6e2" />
                          </button>

                          {this.state.openEffCalendarFlag && (
                            <DayPicker
                              classNames={{
                                root: 'DayPicker',
                                day: 'DayPicker-Day',
                                selected: 'DayPicker-Day--selected',
                                disabled: 'DayPicker-Day--disabled',
                              }}
                              captionLayout="dropdown"
                              formatDate={formatDate}
                              parseDate={parseDate}
                              defaultMonth={
                                modifiedEffDate instanceof Date &&
                                !Number.isNaN(modifiedEffDate.getTime())
                                  ? modifiedEffDate
                                  : ''
                              }
                              startMonth={new Date(currentYear - 1, 0)}
                              endMonth={new Date(currentYear + 10, 12)}
                              selected={this.state.effDate}
                              onSelect={(inDate) => {
                                this.setState({
                                  effDate: inDate,
                                })
                              }}
                              placeholder={'mm/dd/yyyy'}
                              onDayClick={this.handleEffDate}
                              mode="single"
                              /* 
                            Since only UW users can access this popup, we don't need the disabledDays
                            logic. But if Broker users ever access this popup in the future we should
                            add this code back.
                          disabled={
                            this.props.isUnderwriter
                              ? {}
                              :
                                {
                                  from: new Date(currentYear - 1, 0),
                                  to: modifiedInitiatedDate,
                                }
                          }*/
                            />
                          )}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} md={3}>
                        <div className="quote-status-date">*Expiration Date:</div>
                      </Col>
                      <Col xs={4} md={3}>
                        <Cleave
                          id={'effDate'}
                          className={classNames(
                            'form-control',
                            'number-control',
                            'input-numeral',
                            'quote-status-date',
                            {
                              filled: this.state.expDate
                                ? moment(this.state.expDate).format('MM/DD/YYYY')
                                : this.state.expDateHolder,
                            },
                          )}
                          value={
                            this.state.expDate
                              ? moment(this.state.expDate).format('MM/DD/YYYY')
                              : this.state.expDateHolder
                          }
                          placeholder="mm/dd/yyyy"
                          options={{
                            date: true,
                            datePattern: ['m', 'd', 'Y'],
                          }}
                          onChange={this.handleExpDateChange}
                        />
                      </Col>
                      <Col>
                        <div className="modalDatePicker">
                          <button
                            className="calendarButton quote-status-date"
                            onClick={this.handleOpenExpCalendar}
                          >
                            <CalendarDays size={16} color="#42b6e2" />
                          </button>
                          {this.state.openExpCalendarFlag && (
                            <DayPicker
                              classNames={{
                                root: 'DayPicker',
                                day: 'DayPicker-Day',
                                selected: 'DayPicker-Day--selected',
                                disabled: 'DayPicker-Day--disabled',
                              }}
                              captionLayout="dropdown"
                              formatDate={formatDate}
                              parseDate={parseDate}
                              defaultMonth={
                                modifiedExpDate instanceof Date &&
                                !Number.isNaN(modifiedExpDate.getTime())
                                  ? modifiedExpDate
                                  : ''
                              }
                              startMonth={new Date(currentYear - 1, 0)}
                              endMonth={new Date(currentYear + 10, 12)}
                              selected={this.state.expDate}
                              onSelect={(inDate) => {
                                this.setState({
                                  expDate: inDate,
                                })
                              }}
                              placeholder={'mm/dd/yyyy'}
                              onDayClick={this.handleExpDate}
                              mode="single"
                              disabled={{
                                from: new Date(currentYear - 1, 0),
                                to: disableExpDate,
                              }}
                            />
                          )}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} md={12}>
                        {modifiedExpDate.getTime() <= modifiedEffDate.getTime() &&
                          this.state.validExpDate && (
                            <div
                              style={{ fontSize: '10px', color: 'red', lineHeight: 2.0 }}
                            >{`Expiration date should be after the Effective date`}</div>
                          )}
                      </Col>
                    </Row>
                  </>
                )}

              <Row>
                <Col xs={12} md={8}>
                  <button
                    className="btn-default btn save-button2"
                    onClick={this.handleSave}
                    disabled={!(this.state.enableSave && requiredFieldsComplete)}
                  >
                    Save
                  </button>
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={6}>
                  {this.state.saveLoading && (
                    <div>
                      <Loading width="22px" height="22px" />
                    </div>
                  )}
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={6}>
                  <div className="notification-text">
                    {this.state.validationMessages.map((items) => (
                      <div key={items.key} className="error-text">
                        {items.message}
                      </div>
                    ))}
                  </div>
                </Col>
              </Row>
            </Grid>
          </div>
        )}
        {this.state.showPDFPreview && (
          <PDFPreview
            custom_class="confirmationDialog"
            submissionid={this.props.selectedSubmissionRow}
            revision={this.state.selectedRevision}
            show={this.state.showPdf}
            onHide={this.handleHidePdf}
            filterByCoverage={this.state.filterPDFByCoverage}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
})

const connectedChangeQuoteStatusModal = connect(mapStateToProps, {
  updateManualQuoteStatus,
  downloadQuoteRevisionSubmission,
})(ChangeQuoteStatusModal)

export { connectedChangeQuoteStatusModal as ChangeQuoteStatusModal }
